import { create } from "zustand";
import produce from "immer";
import * as api from "../services/item_groups";
import { arrayToByIdsAllIds, createLatestRequestTracker } from "./utils";

const trackListRequest = createLatestRequestTracker();

export const useItemGroupStore = create((set) => ({
  byIds: {},
  allIds: [],
  selectedId: null,
  total: 0,
  fetchSome: async ({ q = "", limit = 20, offset = 0 }) => {
    const isLatestRequest = trackListRequest();
    const some = await api.getSome({ q, limit, offset });
    if (!isLatestRequest()) return;
    set(
      produce((draft) => {
        [draft.byIds, draft.allIds] = arrayToByIdsAllIds(some.data);
        draft.total = some.total;
      }),
    );
  },
  getById: async ({ id }) => {
    const one = await api.getById({ id });
    set(
      produce((draft) => {
        [draft.byIds, draft.allIds] = arrayToByIdsAllIds([one.data]);
        draft.selectedId = one.data.id;
      }),
    );
  },
  setSelectedId: async (id) => {
    set(() => ({ selectedId: id }));
  },
  createOne: async ({ name }) => {
    const one = await api.createOne({ name });
    if (one.data) {
      set(
        produce((draft) => {
          draft.byIds[one.data.id] = one.data;
          draft.allIds.push(one.data.id);
        }),
      );
    }
    return one;
  },
  updateOne: async ({ id, name }) => {
    const one = await api.updateOne({ id, name });
    if (one.data) {
      set(
        produce((draft) => {
          draft.byIds[one.data.id] = one.data;
        }),
      );
    }
    return one;
  },
}));
